<template>
    <v-scale-transition>
        <div style="border-bottom: 1px solid #eee" @mouseover="mouseOver" @mouseout="mouseOut">

            <v-card-text class="pa-0">

                <div class="errorParent text-no-wrap">

                    <!-- LINE NUMBER -->
                    <div class="line-number">
                        <v-sheet tile
                                 width="90"
                                 height="38"
                                 color="grey lighten-2"
                                 class="pa-2 text-right subtitle-1 font-weight-bold">
                            <div v-if="!header" class="grey--text text--darken-1">
                            {{ errorLine }}
                            </div>
                        </v-sheet>
                    </div>

                    <!-- VALUES -->
                    <div v-for="(value, index) in values" class="errorLine subtitle-1 font-weight-bold">
                        <code v-if="value === nullValue">NULL</code>
                        <div v-else :class="getValueClasses(index)">

                            <div class="text-no-wrap pt-2" v-if="!getErrorIndex(index)">
                                {{ value }}
                            </div>

                            <v-tooltip v-else top color="primary" class="body-2">

                                <template v-slot:activator="{ on }">
                                    <div v-on="on" class="text-no-wrap pt-2">
                                        {{ value }}
                                    </div>
                                </template>

                                <span :color="error.columnErrors ? 'error' : 'primary'">
                                    {{ getErrorIndex(index) }}
                                </span>

                            </v-tooltip>

                        </div>
                        <div v-if="values.length > (index + 1)" class="record black--text">,</div>
                    </div>
                </div>

            </v-card-text>

        </div>
    </v-scale-transition>
</template>

<script>

export default {

    components: {},

    props: {
        error: {
            type: Object,
            required: true,
        },
        ignored: {
            type: Array,
            required: true,
        },
        header: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            active: false,
            nullValue: '""'
        }
    },

    computed: {

        errorLine() {
            return this.error.line;
        },
        values() {
            return this.error.data.split(",");
        },
        indices() {
            if (this.error.columnErrors) {
                return this.error.columnErrors.map(columnError => columnError.index);
            }
            return [];
        }
    },

    methods: {

        getErrorIndex(index) {
            if (this.error.columnErrors) {
                let found = this.error.columnErrors.find(error => error.index === index);
                if (found) return found.message;
            }
        },

        getValueClasses(index) {
            if (this.indices.includes(index)) {
                return 'record red--text';
            } else if (index !== null && this.ignored.includes(index)) {
                return 'record grey--text text--lighten-1';
            } else {
                return 'record grey--text text--darken-1';
            }
        },
        mouseOver() {
            this.active = true;
        },
        mouseOut() {
            this.active = false;
        }
    }
}
</script>

<style scoped>

.errorParent {
    display: flex;
    align-items: center;
}

.errorLine {
    display: flex;
    align-items: center;
}

.line-number {
    margin-right: 10px;
    font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
}

.record {
    font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
    padding-left: 0px;
}

</style>
